import { quickbooksAuthenticationRoute } from '../web-routes';

import { isProd, DOMAIN } from './config';

export const QUICKBOOKS = {
  API: 'https://appcenter.intuit.com/connect/oauth2',
  CLIENT_ID: isProd
    ? 'ABtmgliYU4yZLG9oFPmgN2Yo3UYHGuXNMAR0AX7Hpg2EY7b51f'
    : 'AB0GU8azZh5DrDWU8m1GNBTVXMEkyB0V9fxhqiwKNNrJBeeZGV',
  ENVIRONMENT: isProd ? 'production' : 'sandbox',
  SCOPE: 'com.intuit.quickbooks.accounting',
  REDIRECT_URI: `${DOMAIN}${quickbooksAuthenticationRoute()}`,
  XSS_SECURITY_TOKEN: 'tYxDzgru3VB5RbptncbE24r4',
};

export const quickbooksDescription =
  'If you keep track of employees in Quickbooks, we can import them to take advantage of all our great features like messaging, surveys, documents, and more! Any new employees or updates in Quickbooks will automatically be reflected in Team Engine, so no more having to maintain two lists!';
